import React, { useState } from 'react';
import { Card,CardBody, Collapse, Nav, Navbar } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export default function SidebarComponent (){
  const [open, setOpen] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleSubMenu = (id) => {
    setOpen(open === id ? null : id); 
  };

  const menuItems = [    
    {
      id: 1,
      icon: '',
      text: 'Dashboard',
      path: '/dashboard/',
      subMenu: []
    },    
    {
      id: 2,
      icon: '',
      text: 'Newsletters',
      path: '/dashboard/newsletters',
      subMenu: []
    },
    {
      id: 3,
      icon: '',
      text: 'Usuarios',
      path: '/dashboard/usuarios',
      subMenu: []
    },
    {
      id: 4,
      icon: '',
      text: 'Audiencias',
      path: '/dashboard/audiencias',
      subMenu: []
    },
    {
      id: 5,
      icon: '',  
      text: 'Segmentos',
      //path: 'https://themewagon.github.io/kaiadmin-lite/',
      path: '',
      subMenu:[]
      /*subMenu: [
        {
          id: 1,
          icon: '',
          text: 'Tablero',
          path: '#Tablero',
          subMenu: [] 
        }
      ]*/
    },
    {
      id: 6,
      icon: '',
      text: 'Contenido recomendado',
      //path: 'https://themewagon.github.io/mantis-free-react-admin-template/',
      path: '/dashboard/contenido-recomendado',
      subMenu: []
    },
    {
      id: 7,
      icon: '',
      text: 'Audio',
      path: '/dashboard/audio',
      subMenu: [] 
    },
    {
      id: 8,
      icon: '',
      text: 'Bloque de comentarios',
      path: '',
      subMenu: [] 
    },
    {
      id: 9,
      icon: '',
      text: 'Google Ad Manager',
      //path: 'https://themewagon.github.io/Modernize-MUI/',
      path: '',
      subMenu: []      
    },
    {
      id: 10,
      icon: '',
      text: 'Buscado semántico',
      path: '',
      subMenu: [] 
    },
    {
      id: 11,
      icon: '',
      text: 'Asistente Editorial',
      path: '',
      subMenu: [] 
    },
    {
      id: 12,
      icon: '',
      text: 'Video',
      path: '',
      subMenu: [] 
    }
  ];

  const clickMenu = (item) =>{
    if(item.text){
      navigate(item.path);
    }
  }

  return (    
    <Card 
      style={{
        height:'calc(100vh - 70px)',
        overflow:'auto'
      }} 
      className='my-2'
    >
      <CardBody className='p-0'>
      <Nav className="flex-column app-sidebar">
            {menuItems.map(item => (
              <Nav.Item key={item.id}>
                <Nav.Link className='item-a' active={location.pathname ==item.path }
                  onClick={()=>clickMenu(item)}
                  //{/*onClick={item.subMenu.length > 0 ? () => toggleSubMenu(item.id) : clickMenu(item)}*/}
                >
                  {item.icon} {item.text}
                </Nav.Link>
                {item.subMenu.length > 0 && (
                  <Collapse in={open === item.id}>
                    <div>
                      <Nav className="flex-column">
                        {item.subMenu.map(subItem => (
                          <Nav.Item key={subItem.id} className='item-b'>
                            <Nav.Link href={subItem.path}>{subItem.icon} {subItem.text}</Nav.Link>
                          </Nav.Item>
                        ))}
                      </Nav>
                    </div>
                  </Collapse>
                )}
              </Nav.Item>
            ))}
          </Nav>
      </CardBody>
    </Card>
  );
};